import React from "react";
import Navbar from "../components/Navbar/Navbar";
import { Link, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../redux/actions/auth';
import PropTypes from 'prop-types';
import { useState } from "react";



const Login = ({ login, isAuthenticated }) => {
    const [formData, setFormData] = useState({
      email: '',
      password: ''
    });
  
    const { email, password } = formData;
    const [showPassword, setShowPassword] = useState(false);
  
    const onChange = (e) =>
      setFormData({ ...formData, [e.target.name]: e.target.value });
      const toggleShowPassword = () => {
        setShowPassword(!showPassword);
      };
  
    const onSubmit = (e) => {
      e.preventDefault();
      login(email, password);
    };
  
    if (isAuthenticated) {
      return <Navigate to="/dashboard" />;
    }

    return (
        <>
            <Navbar />
            <div>
                <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
                    <div>
                        <a href="/">
                            <h3 className="text-4xl font-bold text-[#00A86B]">
                            Quran LMS
                            </h3>
                        </a>
                    </div>
                    <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white shadow-md sm:max-w-lg sm:rounded-lg">
                        <form onSubmit={onSubmit}>

                            <div className="mt-4">
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700 undefined"
                                >
                                    Email
                                </label>
                                <div className="flex flex-col items-start">
                                    <input
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={onChange}
                                        className="block w-full p-2 bg-gray-100 outline-none mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                    />
                                </div>
                            </div>
                            <div className="mt-4">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700 undefined"
        >
          Password
        </label>
        <div className="flex flex-col items-start">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            value={password}
            onChange={onChange}
            className="block w-full p-2 bg-gray-100 outline-none mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
          <div className="mt-2">
            <input
              type="checkbox"
              id="showPassword"
              onChange={toggleShowPassword}
              checked={showPassword}
              className="mr-2"
            />
            <label htmlFor="showPassword" className="text-sm text-gray-600">
              Show Password
            </label>
          </div>
        </div>
      </div>
                <Link  to= "/forgot-password">
                            <a
                                href="#"
                                className="text-xs text-[#00A86B] hover:underline"
                            >
                                Forget Password?
                            </a>
                            </Link>
                            <div className="flex items-center mt-4">
                                <button className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-[#00A86B] rounded-md hover:bg-[#00b371] focus:outline-none focus:bg-purple-600">
                                    Login
                                </button>
                            </div>
                        </form>

                        <div className="flex items-center w-full my-4">
                            <hr className="w-full" />
                            <p className="px-3 ">OR</p>
                            <hr className="w-full" />
                        </div>
                        <div className="my-6 space-y-2">
                            <button
                                aria-label="Login with Google"
                                type="button"
                                className="flex items-center justify-center w-full p-2 space-x-4 border rounded-md focus:ring-2 focus:ring-offset-1 dark:border-gray-400 focus:ring-violet-400"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 32 32"
                                    className="w-5 h-5 fill-current"
                                >
                                    <path d="M16.318 13.714v5.484h9.078c-0.37 2.354-2.745 6.901-9.078 6.901-5.458 0-9.917-4.521-9.917-10.099s4.458-10.099 9.917-10.099c3.109 0 5.193 1.318 6.38 2.464l4.339-4.182c-2.786-2.599-6.396-4.182-10.719-4.182-8.844 0-16 7.151-16 16s7.156 16 16 16c9.234 0 15.365-6.49 15.365-15.635 0-1.052-0.115-1.854-0.255-2.651z"></path>
                                </svg>
                                <p>Login with Google</p>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

Login.propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool
  };
  
  const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated
  });
  
  export default connect(mapStateToProps, { login })(Login);